module.exports = "https://dashboard.cdn.gifty.nl/6217/images/logo.svg?9c0e9558a6de74cb415462b66a20a062";